<template>
  <div class="com-sidebar">
    <div class="dn-oper">
      <i class="iconfont icon-daohangzixun"></i>
    </div>
    <div class="swiper-container swiper1">
      <div class="swiper-wrapper wrapper1">
        <div class="swiper-slide slide1">
          <a href="" target="_blank" class="dn-left">
            <i class="iconfont icon-zixun"></i>
            <div class="dp-p1">在线咨询</div>
          </a>
        </div>
        <div class="swiper-slide slide1">
          <div class="dn-left">
            <i class="iconfont icon-rexian"></i>
            <div class="dp-p1">服务热线</div>
          </div>
          <div class="dn-right">
            +86-021-36321717
          </div>
        </div>
        <div class="swiper-slide slide1">
          <a href="" target="_blank" class="dn-left">
            <i class="iconfont icon-qq"></i>
            <div class="dp-p1">我要询价</div>
          </a>
        </div>
        <div class="swiper-slide slide1">
          <div class="dn-left">
            <i class="iconfont icon-shang"></i>
            <el-backtop
                :visibility-height="0" :bottom="0" :right="0"></el-backtop>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {}
}
</script>

<style scoped lang="scss">
.com-sidebar {
  position: fixed;
  top: 50%;
  right: -72px;
  transform: translateY(-50%);
  z-index: 101;
  transition: all .3s ease;

  &:hover {
    right: 0;

    .dn-oper {
      opacity: 0;
    }
  }

  .dn-oper {
    position: absolute;
    left: -40px;
    top: 0;
    color: $color1;
    cursor: pointer;
    transition: all .3s ease;
    .iconfont {
      font-size: 40px;
    }
  }

  .swiper1 {
    .wrapper1 {
      flex-direction: column;
      align-items: flex-end;
    }

    .slide1 {
      margin: 0 0 1px 0;
      width: auto;
      display: flex;

      * {
        color: #ffffff;
      }

      &:hover {
        .dn-right {
          display: flex;
          width: 185px;
        }
      }

      &:last-of-type {
        .dn-left {
          background: $background2;
        }
      }

      .dn-left {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 70px;
        height: 70px;
        background: rgba(192, 32, 44, .8);
        font-size: 12px;
        cursor: pointer;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        position: relative;

        .iconfont {
          font-size: 30px;
        }

        .el-backtop {
          width: 100%;
          height: 100%;
          position: absolute;
          border-radius: inherit;
          opacity: 0;
        }
      }

      .dn-right {
        display: none;
        align-items: center;
        justify-content: center;
        background: rgba(192, 32, 44, .8);
        border-left: 1px solid $background2;
        font-size: 20px;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .com-sidebar {

    .swiper1 {
      .slide1 {
        &:hover {
          .dn-right {
            display: flex;
            width: 260*$mobile-conversion;
          }
        }

        .dn-left {
          width: 100*$mobile-conversion;
          height: 100*$mobile-conversion;

          .iconfont {
            font-size: 40*$mobile-conversion;
          }
        }

        .dn-right {
          font-size: 28*$mobile-conversion;
        }
      }
    }
  }
}

</style>
